import React from 'react';
import { parse } from 'date-fns';
import { useStaticQuery, graphql } from 'gatsby';
import { Bar } from 'react-chartjs-2';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core';

import Tab from 'src/components/tab';
import ChartLegend from 'src/components/chartLegend';
import ChartWrapper from 'src/components/chartWrapper';

import { coloredDatasets } from 'src/helpers/chartJsHelpers';

import { setTabExpend } from './slice';



const rawData = {
  '2021-01-01 09:00:00': {
    1: '10',
    2: '9',
    3: '4',
    4: '2',
    5: '0',
    6: '0',
  },
  '2021-01-01 10:00:00': {
    1: '15',
    2: '3',
    3: '3',
    4: '3',
    5: '3',
    6: '2',
  },
  '2021-01-01 13:00:00': {
    1: '1',
    2: '0',
    3: '0',
    4: '0',
    5: '0',
    6: '0',
  },
  '2021-01-01 18:00:00': {
    1: '19',
    2: '9',
    3: '5',
    4: '5',
    5: '1',
    6: '0',
  },
  '2021-01-02 13:00:00': {
    1: '1',
    2: '1',
    3: '1',
    4: '1',
    5: '1',
    6: '1',
  },
  '2021-02-03 14:00:00': {
    1: '13',
    2: '13',
    3: '4',
    4: '1',
    5: '0',
    6: '0',
  },
  '2021-02-04 15:00:00': {
    1: '10',
    2: '2',
    3: '1',
    4: '0',
    5: '0',
    6: '0',
  },
  '2021-02-04 16:00:00': {
    1: '10',
    2: '10',
    3: '5',
    4: '5',
    5: '5',
    6: '3',
  },
  '2021-02-04 17:00:00': {
    1: '25',
    2: '10',
    3: '6',
    4: '2',
    5: '1',
    6: '1',
  },
  '2021-02-04 18:00:00': {
    1: '40',
    2: '40',
    3: '4',
    4: '1',
    5: '1',
    6: '1',
  },
  '2021-02-05 07:00:00': {
    1: '5',
    2: '2',
    3: '2',
    4: '2',
    5: '1',
    6: '1',
  },
  '2021-02-05 08:00:00': {
    1: '0',
    2: '0',
    3: '0',
    4: '2',
    5: '0',
    6: '0',
  },
  '2021-02-05 09:00:00': {
    1: '0',
    2: '9',
    3: '12',
    4: '20',
    5: '0',
    6: '0',
  },
  '2021-02-05 10:00:00': {
    1: '1',
    2: '1',
    3: '1',
    4: '1',
    5: '10',
    6: '0',
  },
};

const datasets = [];
const labels = [];

Object.keys(rawData).forEach((date, index) => {
  labels.push(`${date.split(' ')[0]} 12:00:00`);
  Object.keys(rawData[date]).forEach((label, i) => {
    if (datasets[i]) {
      datasets[i] = {
        label,
        data: [...datasets[i].data, { x: parse(date, 'yyyy-MM-dd HH:mm:ss', new Date()), y: rawData[date][label] }],
        borderWidth: 0,
      };
      //   console.log(dataSet[i]);
    } else {
      datasets[i] = {
        label,
        data: [{ x: parse(date, 'yyyy-MM-dd HH:mm:ss', new Date()), y: rawData[date][label] }],
        borderWidth: 0,
      };
    }
  });
});

const data = coloredDatasets('bar', {
  labels: [...new Set(labels)].map(label => parse(label, 'yyyy-MM-dd HH:mm:ss', new Date())),
  datasets,
});

console.log(data);

const weekDays = ['Monday', 'Tuesday', ' Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

const options = {
  maintainAspectRatio: false,
  cornerRadius: 10,
  fullCornerRadius: false,
  scales: {
    yAxes: [
      {
        stacked: true,
        ticks: {
          beginAtZero: true,
          padding: 20,
        },
        gridLines: {
          drawTicks: false,
          drawBorder: false,
        },
      },
    ],
    xAxes: [
      {
        stacked: true,
        offset: true,
        type: 'time',
        distribution: 'series',
        // bounds: 'ticks',
        time: {
          unit: 'day',
          displayFormats: {
            day: 'DD. MMM',
          },
        },
        ticks: {
          padding: 20,
          source: 'labels',
          // beginAtZero: true,
          // callback: (value, index, values) => {
          //   return [weekDays[index], value];
          // },
        },
        gridLines: {
          display: false,
          // offsetGridLines: false,
        },
        // categoryPercentage: 1,
        // barPercentage: 0.5,
      },
    ],
  },
  legend: {
    display: false,
  },
};

const legend = ['1st Attempt', '2nd Attempt', '3rd Attempt', '4th Attempt', '5th Attempt', '6th Attempt'];

const useStyles = makeStyles(theme => ({}));

const CallActivity = props => {
  const { isTabExpended } = props;
  const classes = useStyles();

  const prismicContent = useStaticQuery(graphql`
    query {
      allPrismicOverview {
        edges {
          node {
            data {
              title5 {
                html
                text
                raw
              }
            }
          }
        }
      }
    }
  `);

  const prismicData = prismicContent.allPrismicOverview.edges[0].node.data;

  const handelExpand = () => {
    props.setTabExpend(!isTabExpended);
  };

  return (
    <Tab title={prismicData.title5.text} drag onClick={handelExpand} expanded={isTabExpended}>
      <ChartLegend legend={legend} maxWidth={750} />
      <ChartWrapper>
        <Bar data={data} options={options} height={300} />
      </ChartWrapper>
    </Tab>
  );
};

const mapStateToProps = ({ me }) => {
  const { overview } = me;
  const { callActivity } = overview;
  return { ...callActivity };
};

const mapDispatchToProps = { setTabExpend };

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(CallActivity));
